import React from "react";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import { useDriveTimePins } from "../../../../utils/DriveTimePin/DriveTimePinContext";
import "./driveTime.css";

/**
 * The navbar readout of the drive-time pins (2026-10-09). Renders NOTHING
 * when nothing is pinned, so the bar is unchanged for everyone else; while
 * pinned it shows "Start · X → End · Y" with a clear on each slot. This is
 * the whole reason pins need no timer — what is pinned is always on screen.
 *
 * MOUNTED TWICE in the navbar, one visible at a time (CSS, the 600px
 * breakpoint): inline in the title row above 600px, and as its own full-width
 * line under the title below it. On a phone the inline one and the two-word
 * title squeezed each other into a wrap — a chip that is `nowrap` wins the
 * row and the title breaks instead. `className` picks the variant.
 */
const Slot = ({ label, place, onClear }) => {
  if (!place) {
    return (
      <span className="dt-chip-slot dt-chip-slot--empty">
        <span className="dt-chip-slot-label">{label}</span>
        none
      </span>
    );
  }
  return (
    <span className="dt-chip-slot">
      <span className="dt-chip-slot-label">{label}</span>
      <span className="dt-chip-slot-name" title={place.label}>
        {place.label}
      </span>
      <button
        type="button"
        className="dt-chip-x"
        aria-label={`Clear ${label.toLowerCase()} pin`}
        title={`Clear ${label.toLowerCase()} pin`}
        onClick={onClear}
      >
        ×
      </button>
    </span>
  );
};

const DriveTimePinChip = ({ className = "" }) => {
  const pins = useDriveTimePins();
  if (!pins.hasAny) return null;

  return (
    <div
      className={`dt-chip ${className}`.trim()}
      role="group"
      aria-label="Drive time pins"
      /* "web:drive-time-pins" anchor; on both mounts, the engine takes the
         visible one (tours/tourEngine.js). */
      data-tour="drive-time-chip"
    >
      <AltRouteIcon sx={{ fontSize: 16 }} aria-hidden="true" />
      <Slot label="Start" place={pins.start} onClear={pins.clearStart} />
      <span className="dt-chip-arrow" aria-hidden="true">
        →
      </span>
      <Slot label="End" place={pins.end} onClear={pins.clearEnd} />
    </div>
  );
};

export default DriveTimePinChip;
